import * as DomTypeUtils from '@packages/systems/core/utils/DomTypeUtils';
import type {Context} from '../types';

// Make sure elements that can't have descendants have no legacy 'v' value
export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {data = {}} = jsonNode;
  const hasDynBoundHtml = DomTypeUtils.isDynBoundHtml(data);
  const isSymbolInstance = DomTypeUtils.isSymbolInst(data);
  const isTextArea = DomTypeUtils.isFormTextarea(data);
  const hasVProp = jsonNode.hasOwnProperty('v');

  return {
    needed: (hasDynBoundHtml || isSymbolInstance || isTextArea) && hasVProp,
    logData: {
      msg: `Node has innerHTML but shouldn't`,
      meta: {
        hasDynBoundHtml,
        isSymbolInstance,
        isTextArea,
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      // eslint-disable-next-line webflow/no-delete
      delete jsonNode.v;
    },
  };
};
